export const SearchDiscountCouponInputComponent = {
  templateUrl:
    './app/ajs/_shared/components/search-discount-coupon-input/search-discount-coupon-input.component.html',
  bindings: {
    booking: '<',
    discountCouponSelected: '&',
    discountCouponApplied: '&',
    discountCouponDeleted: '&',
  },
  controller: SearchDiscountCouponInputController,
  controllerAs: 'vm',
};

SearchDiscountCouponInputController.$inject = ['BookingService', 'DiscountCouponService'];

function SearchDiscountCouponInputController(BookingService, DiscountCouponService) {
  const vm = this;

  // public properties
  // -----------------------
  vm.isDiscountCouponApplied = false;
  vm.invalidDiscountCoupon = false;

  vm.$onChanges = function () {
    if (vm.booking.discount_coupon_id) {
      // vm.booking.discount_coupon =
      // DiscountCouponService.setDiscounCoupon(vm.booking.discount_coupon, vm.booking.discount_coupon.price_list.currency);
      // vm.booking.currency)
      vm.isDiscountCouponApplied = true;
    }
  };

  // public methods
  // -----------------------
  vm.searchDiscountCoupon = function (search) {
    if (search.length < 2) return;

    let params = {
      get: 'current',
      by_coupon: search,
      by_price_list_id: vm.booking.price_list_id,

      // price_list_id:    vm.booking.price_list_id,
      // currency_id:      vm.booking.currency_id,
      skip_check_role: true,
    };

    return DiscountCouponService.getDiscountCoupons(params).then(function (data) {
      return data.items.map((discount_coupon) => {
        return DiscountCouponService.setDiscounCoupon(
          discount_coupon,
          discount_coupon.price_list.currency
        );
      });
    });
  };

  vm.selectDiscountCoupon = function (discount_coupon) {
    vm.invalidDiscountCoupon = false;

    vm.discountCouponSelected({ $discountCoupon: discount_coupon });
  };

  vm.validateDiscountCoupon = function () {
    if (!vm.booking.discount_coupon) {
      vm.invalidDiscountCoupon = false;
    }
  };

  vm.clearDiscountCouponInput = function () {
    vm.invalidDiscountCoupon = false;
    vm.invalidDiscountCouponMsg = '';

    vm.booking.discount_coupon = '';
  };

  vm.applyDiscountCoupon = function () {
    vm.invalidDiscountCoupon = false;

    if (!vm.booking.discount_coupon || !vm.booking.discount_coupon.id) {
      vm.invalidDiscountCoupon = true;
      return;
    }

    vm.sendingDiscountCoupon = true;

    let successCallback = (data) => {
      vm.sendingDiscountCoupon = false;

      vm.isDiscountCouponApplied = true;

      vm.discountCouponApplied({ $booking: data });
    };

    let errorCallback = () => {
      // errors
      vm.invalidDiscountCoupon = true;

      vm.sendingDiscountCoupon = false;
    };

    BookingService.applyDiscountCoupon(
      vm.booking.id,
      vm.booking.discount_coupon.id,
      successCallback,
      errorCallback
    );
  };

  vm.deleteDiscountCoupon = function () {
    if (!vm.isDiscountCouponApplied) return;

    let successCallback = (data) => {
      vm.isDiscountCouponApplied = false;
      vm.invalidDiscountCoupon = false;

      vm.discountCouponDeleted({ $booking: data }); // vm.booking
    };

    BookingService.deleteDiscountCoupon(vm.booking.id, successCallback);
  };
}
